import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import Timers from 'src/components/Timers';
import Timer from 'src/store/models/Timer';
import Entry from 'src/store/models/Entry';
import { dialog } from 'src/boot/mixins.js'; // import _ from 'lodash'

export default {
  mixins: [dialog],
  components: {
    TeDialog: TeDialog,
    Timers: Timers
  },
  computed: {
    timers: function timers() {
      return Timer.query().where('user_id', this.me.user_id).with(['project', 'user', 'user.avatar', 'phase']).get();
    }
  },
  methods: {
    saveAsEntries: function saveAsEntries() {
      var _this = this;

      this.showLoading();
      this.$axios.post('/timers/save-many-as-entries', {
        timers: this.timers.reduce(function (acc, timer) {
          acc.push(timer.timer_id);
          return acc;
        }, [])
      }).then(function (response) {
        Timer.$getOldTimersCount();

        _this.timers.forEach(function (timer) {
          Timer.delete(timer.timer_id);
        });

        Entry.insertOrUpdate({
          data: response.data
        });

        _this.hide();

        _this.$q.notify({
          message: _this.$t('components.timersDialog.timers_saved'),
          type: 'positive'
        });
      }).catch(function () {
        _this.$q.notify({
          message: _this.$t('components.timersDialog.problem_occured_while_saving'),
          type: 'negative'
        });
      }).finally(function () {
        _this.hideLoading();
      });
    }
  }
};